import { useUI, useFile } from '../context/AppContext.jsx';
import { getWaypointStats } from '../services/WaypointService.js';

export default function StatusBar() {
  const { statusMessage, statusType } = useUI();
  const { currentWaypoints, currentFeatures } = useFile();
  
  const stats = getWaypointStats(currentWaypoints);
  
  const statusColors = {
    info: 'text-blue-400',
    success: 'text-green-400',
    error: 'text-red-400',
    warning: 'text-yellow-400',
  };
  
  return (
    <footer className="bg-bg-secondary border-t border-border px-4 py-2 flex justify-between items-center">
      <div className={`status-message ${statusColors[statusType] || statusColors.info}`}>
        {statusMessage}
      </div>
      <div className="text-text-secondary text-sm flex gap-4">
        <span>Waypoints: {stats.count}</span>
        {stats.hasViaPoints > 0 && <span>Via-points: {stats.hasViaPoints}</span>}
        <span>Features: {currentFeatures.length}</span>
      </div>
    </footer>
  );
}


